const prod = {
  prod: true,
  url: {
    PATH_URL: 'https://meucarrinho.delivery',
  },
};
const dev = {
  prod: false,
  url: {
    PATH_URL: 'https://dev.meucarrinho.delivery',
  },
};

export const config =
  window.location.href.indexOf('dev') !== -1 ||
  window.location.href.indexOf('localhost') !== -1
    ? dev
    : prod;
export const states = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export const LocalStorageName = '@MeuCarrinhoApp:';

export const WeekDays = [
  { id: 1, weekday: 'Segunda' },
  { id: 2, weekday: 'Terça' },
  { id: 3, weekday: 'Quarta' },
  { id: 4, weekday: 'Quinta' },
  { id: 5, weekday: 'Sexta' },
  { id: 6, weekday: 'Sábado' },
  { id: 7, weekday: 'Domingo' },
];

export const delay = (amount = 3000) =>
  new Promise(resolve => {
    setTimeout(resolve, amount);
  });
